import { render } from "./NotificationManager.vue?vue&type=template&id=4e8456dc&scoped=true"
import script from "./NotificationManager.vue?vue&type=script&lang=js"
export * from "./NotificationManager.vue?vue&type=script&lang=js"

import "./NotificationManager.vue?vue&type=style&index=0&id=4e8456dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e8456dc"]])

export default __exports__